import { CommandProcessor } from './terminal'
var _session = null
function processor (session){
    _session = session
    if(_session.state.typed == "") return ""
    var cmd = new CommandProcessor("")
    return commandLookup(cmd.digest(_session.state.typed))
}

// d| means directory
// f| means file
var files = {
    'd|4.0|guest|.': [],
    'd|4.0|root|..': [],
    'd|4.0|guest|.ssh': [],
    'd|4.0|guest|.cache': [],
    // 'f|15|guest|portfolio.txt': `
    //     <strong>Komunitas YES Indo Bisa</strong> - https://komunitasyesindobisa.com/<br/>
    //     > Multi Level Marketing Membership and Web Seminar. Developed with Laravel Framework.<br/>
        
    //     <strong>Jhajam</strong> - https://jhajam.stts.edu/<br/>
    //     > A simple web app to predict your favorite music. Jhajam is one of Big Data Class Project in 2019.<br/>
    // `,
    'f|15|guest|interests.txt': `
        My most interests are:<br/>
        > Machine Learning<br/>
        > Data Science<br/>
        > Flutter<br/>
        > VueJS<br/>
        > Security<br/>
        > Laravel<br/>
        > Python<br/>
        And many more...<br/>
    `,
    'f|2.0|guest|contact.txt': 'arcphysx@gmail.com',
    'f|3.0|guest|linkedin.txt': 'https://linkedin.com/in/arcphysx',
    'f|3.0|guest|github.txt': 'https://github.com/arcphysx',
    'f|3.0|guest|gitlab.txt': 'https://gitlab.com/arcphysx',
}

{/* <table border="0">
    <tr>
        <td>Machine Learning</td>
        <td>[############--------]</td>
    </tr>
    <tr>
        <td>Data Science</td>
        <td>[##############------]</td>
    </tr>
    <tr>
        <td>Flutter</td>
        <td>[####################]</td>
    </tr>
    <tr>
        <td>Vue</td>
        <td>[####################]</td>
    </tr>
    <tr>
        <td>Security</td>
        <td>[####################]</td>
    </tr>
</table> */}
var commands = {
    'whoami': () => {
        return _session.state.username
    },
    'clear': () => {
        _session.history = []
        return 
    },
    'reboot': () => {
        setTimeout(() => {_session.reboot()}, Math.floor(Math.random()*1000)+500)
        return `starting reboot...`
    },
    'exit': () => {
        _session.reboot()
        window.history.back()
        return 
    },
    'ls': (digested) => {
        let args = "";
        let params = digested.parameters.param
        for (let k in params) {
            let invalid = ''
            Object.keys(params[k])[0].split('').forEach(char => {
                if(
                    char == 'l' ||
                    char == 'a'
                ) args += char
                else invalid = char
            })
            if(invalid != '') return `${digested.parameters.command}: invalid option -- '${invalid}'`
        }
        let output = ""
        if(args.includes('l')){
            output += "<table border='0'>"
            for (let [key] of Object.entries(files)) {
                let [type, size, owner, val] = key.split('|')
                if(val.charAt(0) == '.' && !args.includes('a') && val.length > 2) continue;
                output += `
                    <tr>
                        <td>${type == 'd' ? 'd' : '-'}r--r--r--</td>
                        <td>1<td>
                        <td>${owner}<td>
                        <td>${owner}<td>
                        <td>${size}K<td>
                        <td>Jul<td>
                        <td>26<td>
                        <td>20:21<td>
                        <td>${val}<td>
                    </tr>
                `
            }
            output += "</table>"
            return output
        }

        for (let [key] of Object.entries(files)) {
            let spl = key.split('|')
            if(spl[3].charAt(0) == '.' && !args.includes('a') && spl[3].length > 2) continue;
            output += spl[3] + '<br/>'
        }
        return output
    },
    'cat': (digested) => {
        if(digested.parameters.param.length <= 0){
            return `<br/>`
        }
        if(
            digested.parameters.param.length > 0 && 
            typeof digested.parameters.param[0]['-'] != 'undefined'
        ){
            for (let [key, value] of Object.entries(files)) {
                let spl = key.split('|')
                if(spl[3] == digested.parameters.param[0]['-']){
                    return value
                }
                console.log(spl[3], digested.parameters.param[0]['-'], spl[3] == digested.parameters.param[0]['-'])
            }
            return `${digested.parameters.command}: ${digested.parameters.param[0]['-']}: No such file or directory`
        }
        return `${digested.parameters.command}: invalid option -- '${Object.keys(digested.parameters.param[0])[0]}'`
    },
    'cd': (digested) => {
        if(digested.parameters.param.length <= 0){
            return `<br/>`
        }
        return `${digested.parameters.command}: ${digested.parameters.param[0]['-']}: Permission denied`
    },
    'touch': (digested) => {
        if(digested.parameters.param.length <= 0){
            return `${digested.parameters.command}: missing file operand`
        }
        if(
            digested.parameters.param.length > 0 && 
            typeof digested.parameters.param[0]['-'] != 'undefined'
        ){
            return `${digested.parameters.command}: cannot touch '${digested.parameters.param[0]['-']}': Permission denied`
        }
        return `${digested.parameters.command}: invalid option -- '${Object.keys(digested.parameters.param[0])[0]}'`
    },
    'rm': (digested) => {
        if(digested.parameters.param.length <= 0){
            return `${digested.parameters.command}: missing operand`
        }
        if(
            digested.parameters.param.length > 0 && 
            typeof digested.parameters.param[0]['-'] != 'undefined'
        ){
            return `${digested.parameters.command}: cannot remove '${digested.parameters.param[0]['-']}': Permission denied`
        }
        if(
            typeof digested.parameters.param[0]['r'] != 'undefined' || typeof digested.parameters.param[0]['R'] != 'undefined'
        ){
            if(typeof digested.parameters.param[1]['-'] != 'undefined'){
                return `${digested.parameters.command}: cannot remove '${digested.parameters.param[1]['-']}': Permission denied`
            }
            return `${digested.parameters.command}: missing operand` 
        }
        return `${digested.parameters.command}: invalid option -- '${Object.keys(digested.parameters.param[0])[0]}'`
    },
    'rmdir': (digested) => {
        if(digested.parameters.param.length <= 0){
            return `${digested.parameters.command}: missing operand`
        }
        if(
            digested.parameters.param.length > 0 && 
            typeof digested.parameters.param[0]['-'] != 'undefined'
        ){
            return `${digested.parameters.command}: cannot remove '${digested.parameters.param[0]['-']}': Permission denied`
        }
        return `${digested.parameters.command}: invalid option -- '${Object.keys(digested.parameters.param[0])[0]}'`
    },
    'mv': (digested) => {
        if(digested.parameters.param.length <= 0){
            return `${digested.parameters.command}: missing file operand`
        }
        if(
            digested.parameters.param.length > 0 && 
            typeof digested.parameters.param[0]['-'] != 'undefined'
        ){
            return `${digested.parameters.command}: cannot remove '${digested.parameters.param[0]['-']}': Permission denied`
        }
        return `${digested.parameters.command}: invalid option -- '${Object.keys(digested.parameters.param[0])[0]}'`
    },
    'sudo': (digested) => {
        if(
            digested.parameters.param.length > 0 && 
            typeof digested.parameters.param[0]['-'] != 'undefined'
        ){
            return `${digested.parameters.command}: ${digested.parameters.param[0]['-']}: Permission denied`
        }
        return `${digested.parameters.command}: Permission denied`
    },
    'help': () => {
        return `
            <strong>whoami</strong> - print effective userid<br/>
            <strong>clear</strong> - clear the terminal screen<br/>
            <strong>cd</strong> - change the shell working directory<br/>
            <strong>ls</strong> - list directory contents<br/>
            <strong>cat</strong> - concatenate files and print on the standard output<br/>
            <strong>mv</strong> - move (rename) files<br/>
            <strong>rm</strong> - remove files or directories<br/>
            <strong>rmdir</strong> - remove empty directories<br/>
            <strong>touch</strong> - change file timestamps<br/>
            <strong>sudo</strong> - execute a command as another user<br/>
            <strong>exit</strong> - cause normal process termination<br/>
            <strong>reboot</strong> - reboot the machine<br/>
            <strong>help</strong> - print available command
        `
    }
}

function commandLookup(digested){
    try{
        return commands[digested.parameters.command](digested);
    }catch(ex){
        return `${digested.parameters.command}: command not found.`
    }
}

export { processor }